/* eslint-disable operator-linebreak */
export const ERROR_402_WHAPI =
  'The limit of requests has been exceeded, please contact customer service.';
export const ERROR_500_WHAPI = 'Your order could not be completed, please try again later.';
export const SUCCES_200_WHAPI = 'Order successfully shipped';
